<script>
import {api} from "@/modules/api";
import DeliveryHistory from "@/components/ordering/details/DeliveryHistory.vue";
import ProductListOrderDetail from "@/components/ordering/details/ProductListOrderDetail.vue";
import SummaryDetailOrder from "@/components/ordering/details/SummaryDetailOrder.vue";
import BreadcrumpsProfil from "@/components/BreadcrumpsProfil.vue";
import {useAuthStore} from "@/stores/auth";
import {mapStores} from "pinia";
import BreadcrumpAdmin from "@/components/BreadcrumdAdmin.vue";

export default {
  name: 'PanelDetailOrder',
  components: {BreadcrumpAdmin, BreadcrumpsProfil, SummaryDetailOrder, ProductListOrderDetail, DeliveryHistory},
  data () {
    return {
      order: {},
      apiUrl: process.env.VUE_APP_API_URL
    }
  },
  mounted () {
    this.loadData()
  },
  computed: {
    ...mapStores(useAuthStore)
  },
  methods: {
    loadData () {
      api.cart.getById(this.$route.params.id).then(res => {
        this.order = res
      })
    }
  }
}
</script>

<template>
  <section class="bg-white py-8 antialiased dark:bg-gray-900 md:py-16">
    <div class="mx-auto max-w-screen-xl px-4 2xl:px-0">
      <breadcrumps-profil
        v-if="!authStore.isAdmin || $route.name !== 'app_order_admin_detail'"
        :first-items="{ text: 'Mes commandes', url: 'app_orders' }"
        :second-items="{ text: `#${order.numberOrder}`, url: 'app_order_detail' }"
      />
      <breadcrump-admin
        v-else
        :first-items="{ text: 'Commandes', url: 'app_admin_order' }"
        :second-items="{ text: `#${order.numberOrder}` }"
      />
      <h2 class="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl">
        Suivi de la commande #{{ order.numberOrder }} -
        <a :href="apiUrl +'/pdf/bon-de-commande/' + order.id" class="hover:underline" target="_blank">
          Facture <i class="fa-solid fa-download ml-2"></i>
        </a>
      </h2>

      <div class="mt-6 sm:mt-8 lg:flex lg:gap-8">
        <div class="w-full divide-y divide-gray-200 overflow-hidden rounded-lg border border-gray-200 dark:divide-gray-700 dark:border-gray-700 lg:max-w-xl xl:max-w-2xl">
          <product-list-order-detail v-for="(productCart, index) in order.productsCart" :key="index" :product-cart="productCart" />
          <summary-detail-order v-if="order.productsCart" :products-cart="order.productsCart" />
        </div>

        <delivery-history :order="order" />
      </div>
    </div>
  </section>
</template>

<style scoped>

</style>